// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"register_wrapper__YZvn2","texts":"register_texts__o4dOs","p":"register_p__ZlINu","remember":"register_remember__F7TVT","actionWith":"register_actionWith__MWK56"};